import { Type } from "class-transformer";
export class DhUpdateFileDto {
    name: string;
    @Type(() => Date)
    changeDateUtc: Date;
    size = 0;
    content: string;
}
